import { NavigationBack, Typography } from "@/components";
import FloatingSearchV2 from "@/components/ui/floating-search/v2";
import AppBar from "@mui/material/AppBar";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Toolbar from "@mui/material/Toolbar";
import { useLocation, useNavigate, useSearch } from "@tanstack/react-router";

const TabsLinks = ["/dashboard/chat/single", "/dashboard/chat/group"];

const AppBarChat = () => {
	const activeTab = useLocation({
		select: (state) =>
			TabsLinks.findIndex((link) => state.pathname.includes(link)) || 0,
	});
	const navigate = useNavigate();
	const searchQ = useSearch({
		strict: false,
		select: (state) => state.q ?? "",
	});
	const onChangeSearch = (search: string) => {
		return navigate({
			replace: true,
			search: {
				// @ts-expect-error
				q: search || undefined,
			},
		});
	};
	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		event.preventDefault();
		return navigate({
			replace: true,
			to: TabsLinks[newValue],
		});
	};
	return (
		<AppBar
			position="relative"
			color="transparent"
			className="!bg-gradient-chat [&_*_]:text-white"
		>
			<Toolbar>
				<NavigationBack />
				<div className="w-full relative flex gap-1 justify-between py-3">
					<FloatingSearchV2
						name="search"
						value={searchQ}
						onClear={() => onChangeSearch("")}
						onChange={(e) => onChangeSearch(e.target.value)}
						className="!rounded-xl"
						inputClassName="!rounded-xl"
					>
						<div className="flex items-center">
							<Typography fontWeight={700} fontSize={16}>
								Chats
							</Typography>
						</div>
					</FloatingSearchV2>
				</div>
			</Toolbar>
			<Toolbar classes={{ root: "!p-0 !items-end" }}>
				<Tabs
					value={activeTab}
					onChange={handleChange}
					indicatorColor="primary"
					textColor="inherit"
					variant="fullWidth"
					aria-label="full width tabs example"
					className="w-full [&_span.MuiTabs-indicator]:!bg-white"
				>
					<Tab label="1 to 1" sx={{ textTransform: "none" }} />
					<Tab label="Group" sx={{ textTransform: "none" }} />
				</Tabs>
			</Toolbar>
		</AppBar>
	);
};

export default AppBarChat;
